import React from "react";
import AboutHeader from "../../components/aboutHeader/aboutHeader";
import Footer from "../../components/footer/footer";

export default function PageNotFound() {
  return (
    <div>
      <AboutHeader />
      <div>
        <img
          src="images/pagenotfound.png"
          class="img-responsive"
          alt="img"
          style={{ width: "100%", height: "100vh" }}
        />
      </div>
      <Footer />
    </div>
  );
}
